import { render } from "./breadcrumb-doctor.vue?vue&type=template&id=5ad0bb24"
import script from "./breadcrumb-doctor.vue?vue&type=script&lang=js"
export * from "./breadcrumb-doctor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__